module.exports = __webpack_public_path__ + "media/stylesheets/images/spritesheet-a4e0eb7ad904a4858361202555b38aee.svg";